// src/services/dropbox.js
import { functions } from "@/config/firebaseInit";
import "firebase/functions";

export async function getTemporaryLink(path) {
  const dropboxGetTempLink = functions.httpsCallable(
    "dbxApi-dropboxGetTempLink"
  );
  const { data } = await dropboxGetTempLink({ path });
  return data.link; // dl.dropboxusercontent.com URL
}

/**
 * Convenience: try .png then .jpg (lowercase), return first that exists.
 * @param {string} basePath e.g. "/certs/569667/123456"
 */
export async function resolvePngOrJpg(basePath) {
  const tryList = [`${basePath}.png`, `${basePath}.jpg`];
  for (const p of tryList) {
    try {
      return await getTemporaryLink(p);
    } catch (e) {
      console.log({ e });
      /* continue */
    }
  }
  throw new Error("No .png or .jpg found at " + basePath);
}
